// src/components/common/RiskGauge.jsx
import React from 'react';
import { Box, Typography } from '@mui/material';
import {
    PieChart, Pie, Cell, ResponsiveContainer,
    Label
} from 'recharts';

const RiskGauge = ({ value }) => {
    // Ensure value is within 1-10 range
    const normalizedValue = Math.min(10, Math.max(1, value));

    // Calculate percentage for the gauge
    const percentage = (normalizedValue - 1) / 9 * 100;

    // Determine color based on risk score
    const getColor = (score) => {
        if (score >= 7) return '#f44336'; // High risk - red
        if (score >= 4) return '#ff9800'; // Medium risk - orange
        return '#4caf50'; // Low risk - green
    };

    const color = getColor(normalizedValue);

    // Data for pie chart
    const data = [
        { name: 'Risk', value: percentage },
        { name: 'Empty', value: 100 - percentage }
    ];

    return (
        <Box sx={{ width: '100%', height: 200 }}>
            <ResponsiveContainer>
                <PieChart>
                    <Pie
                        data={data}
                        cx="50%"
                        cy="50%"
                        startAngle={180}
                        endAngle={0}
                        innerRadius="60%"
                        outerRadius="80%"
                        paddingAngle={0}
                        dataKey="value"
                        stroke="none"
                    >
                        <Cell key="risk" fill={color} />
                        <Cell key="empty" fill="#e0e0e0" />
                        <Label
                            content={({ viewBox }) => {
                                const { cx, cy } = viewBox;
                                return (
                                    <g>
                                        <text
                                            x={cx}
                                            y={cy}
                                            textAnchor="middle"
                                            dominantBaseline="middle"
                                            fontSize="28"
                                            fontWeight="bold"
                                            fill={color}
                                        >
                                            {normalizedValue.toFixed(1)}
                                        </text>
                                        <text
                                            x={cx}
                                            y={cy + 25}
                                            textAnchor="middle"
                                            dominantBaseline="middle"
                                            fontSize="14"
                                            fill="#666"
                                        >
                                            out of 10
                                        </text>
                                    </g>
                                );
                            }}
                        />
                    </Pie>
                </PieChart>
            </ResponsiveContainer>
        </Box>
    );
};

export default RiskGauge;